<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="content">
                    <status-order
                        @os="orderStatus"
                        :orderResult="orderResult"/>                    
                </div>
                <center>                                        
                   <button
                        @click="newOrder" 
                        v-if="isCompleted"
                        class="btn btn-danger" >New Order</button>
                </center>    
            </div>
            <div class="col-md-4">
                <div class="content" id="width-of-sidebar"></div>
                <shopping-cart type="order" />
            </div>            
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import ShoppingCart from "@/components/menu/ShoppingCart"
import StatusOrder from '@/components/menu/StatusOrder'

export default {
    name: 'OrderResult',
    components: {
        ShoppingCart,
        StatusOrder
    },
    computed: {
        ...mapState({
            orderResult: 'orderResult'
        }),
        isCompleted(){
            return  this.os!=null && (this.os.status==='Done' || this.os.status==='Cancelled' || this.os.status==='Rejected')
        }        
    },
    data() {
        return {
            os : null
        }
    },
    methods:{
        orderStatus(os){
            this.os = os
        },
        newOrder(){
            this.$store.dispatch('new_order')
            this.$router.replace({name: "Home"}).catch(()=>{});
        }
    }    
}
</script> 